<template>
  <div>
    <b-card no-body class="bdr-tabs">
      <b-tabs card>
        <b-tab 
          v-if="!isSalesManagerAccount"
          title="Обработка лидов" 
          lazy 
          style="padding-top: 0; padding-bottom: 0;"
        >
          <b-card-text>
            <LeadsAnalytic />
          </b-card-text>
        </b-tab>
        <b-tab 
          title="Заявки VS Поставки"
          active 
          style="padding-top: 0; padding-bottom: 0;"
        >
          <b-card-text>
            <OrdersVsSupplies />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>    
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  import LeadsAnalytic from '@components/orders/analytic/LeadsAnalytic';
  import OrdersVsSupplies from '@components/orders/analytic/OrdersVsSupplies';

  export default {
    name: "OrderAnalytic",

    components: {
      LeadsAnalytic,
      OrdersVsSupplies
    },

    computed: {
      ...mapGetters("auth", ["currentUser"]),

      isSalesManagerAccount() {
        return this.currentUser.role.includes('sales-manager');
      },
    }
  };
</script>